
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";

import Home from "./Pages/Home";
import About from "./Pages/About";
import Contact from "./Pages/Contact";
import Reservation from "./Pages/Reservation";
import Nav from "./Pages/Nav";
import Login from "./Pages/Login";
import CardGrid from "./Pages/CardGrid";
import HotelGrid from "./Pages/Hotel/HotelGrid";
import StudentGrid from "./Pages/Student/StudentGrid";
import LodgeGrid from "./Pages/Lodge/LodgeGrid";
import Checkin from "./Pages/Checkin";
import StudentRegistrationForm from "./Pages/StudentApply/StudentRegistrationForm";
import Dashboard from "./Pages/StudentDashBoard/Dashboard";
import ResidenceAdminDashboard from "./Pages/ResidenceAdminDashboard/ResidenceAdminDashboard";
import ForgetPassword from "./Pages/ForgetPassword";
import ResetPassword from "./Pages/ResetPassword";
import VerifyEmail from "./Pages/StudentApply/VerifyEmail";
import ResidenceAdminLogin from "./Pages/ResidenceLogin/ResidenceAdminLogin";
import RoomPage from "./Pages/ResidenceAdminDashboard/RoomPage";

import BubbleBackground from "./Pages/Background/BubbleBackground";
import { DocumentProvider } from "./Pages/DocumentsF/DocumentContext";
import MsaSupportAdminDashboard from "./Pages/MSAadmidlogin/MsaSupportAdminDashboard";
import MsaAdminLogin from "./Pages/MSAadmidlogin/MsaAdminLogin";
import Teammemberdashboard from "./Pages/MSAadmidlogin/Teammemberdashboard";
import Teammemberlogin from "./Pages/MSAadmidlogin/Teammemberlogin";
import TeamMemberDashboard from "./Pages/MSAadmidlogin/Teammemberdashboard"

function AppWrapper() {
  const location = useLocation();

  // Routes where Nav should be hidden
  const hideNavRoutes = [
    "/",
    "/login",
    "/ResidenceLogin",
    "/Dashboard",
    "/ResidenceAdminDashboard",
    "/reset-password",
    "/forgot-password",
    "/register",
    "/MsaAdminLogin",
    "/Teammemberlogin",
    "/Teammemberdashboard",
    "/MSASupportAdminDashboard",
    "/TeamMemberDashboard"
  ];

  // Regex to match /residences/:residenceId/rooms
  const roomPageRegex = /^\/residences\/[^/]+\/rooms$/;

  const shouldHideNav =
    hideNavRoutes.includes(location.pathname) ||
    roomPageRegex.test(location.pathname);

  // Routes that should NOT have bubble background
  const noBackgroundRoutes = [
    "/",
    "/login",
    "/ResidenceLogin",
  
  ];

  const useBubbleBackground = !noBackgroundRoutes.includes(location.pathname);

  const AppContent = (
    <>
      {!shouldHideNav && <Nav />}

      <DocumentProvider>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/ResidenceLogin" element={<ResidenceAdminLogin />} />
          <Route path="/home" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/reservation" element={<Reservation />} />
          <Route path="/CardGrid" element={<CardGrid />} />
          <Route path="/HotelGrid" element={<HotelGrid />} />
          <Route path="/StudentGrid" element={<StudentGrid />} />
          <Route path="/LodgeGrid" element={<LodgeGrid />} />
          <Route path="/Checkin" element={<Checkin />} />
          <Route path="/register" element={<StudentRegistrationForm />} />
          <Route path="/Dashboard" element={<Dashboard />} />
          <Route path="/forgot-password" element={<ForgetPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/MsaAdminLogin" element={<MsaAdminLogin />} />
          <Route path="/Teammemberlogin" element={<Teammemberlogin />} />
          <Route path="/Teammemberdashboard" element={<Teammemberdashboard />} />
          <Route path="/MsaSupportAdminDashboard" element={<MsaSupportAdminDashboard />} />  
          <Route path="/TeamMemberDashboard" element={<TeamMemberDashboard />} />    
          <Route
            path="/ResidenceAdminDashboard"
            element={<ResidenceAdminDashboard />}
          />
          <Route
            path="/residences/:residenceId/rooms"
            element={<RoomPage />}
          />
        </Routes>
      </DocumentProvider>
    </>
  );

  return (
    <div className="App">
      {useBubbleBackground ? (
        <BubbleBackground>{AppContent}</BubbleBackground>
      ) : (
        AppContent
      )}
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppWrapper />
    </Router>
  );
}

export default App;
